import {
  useBrokersServiceBrokersUsersInviteCreate,
  useBrokersServiceBrokersUsersListKey
} from '@insurance/api/queries'
import { BrokerInviteUser } from '@insurance/api/requests'
import { replaceEmptyWithUndefined, showApiErrors } from '@shared/utils'
import { useQueryClient } from '@tanstack/react-query'
import { App, Modal } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { CommonPropsAgent } from './types'

export const ReInviteAgent = ({
  data,
  onSuccess,
  open,
  onCancel
}: CommonPropsAgent) => {
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal()
  const { message } = App.useApp()
  const queryClient = useQueryClient()

  const { mutateAsync: reInviteMutation } =
    useBrokersServiceBrokersUsersInviteCreate({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [useBrokersServiceBrokersUsersListKey]
        })

        message.success(t('re_invited_successfully'))

        onSuccess()
      },
      onError: (error) => showApiErrors(error)
    })

  useEffect(() => {
    const id = data?.id
    if (!id) return

    const { destroy } = modal.confirm({
      title: t('re_invite_confirm'),
      content: t('re_invite_confirm_description'),
      okText: t('re_invite'),
      cancelText: t('cancel'),
      onOk: () =>
        reInviteMutation({
          requestBody: replaceEmptyWithUndefined({
            ...data,
            force: true
          }) as BrokerInviteUser
        }),
      open,
      onCancel
    })

    return destroy
  }, [data, reInviteMutation, modal, onCancel, open, t])

  return contextHolder
}
